var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.527 7.457c.654.692 1.027 1.524 1.16 2.453.027.19.045.382.05.573.01.33-.185.517-.525.517H.535c-.354 0-.536-.178-.535-.52.006-2.138 1.65-4.093 3.824-4.512 1.85-.357 3.431.146 4.703 1.49Zm5.375 1.028c.061.244.084.5.097.75.016.307-.19.494-.518.495-.632.002-1.264 0-1.896 0-.287 0-.574-.001-.86.001-.078.001-.12-.01-.137-.1-.23-1.252-.81-2.323-1.785-3.188-.02-.018-.039-.04-.066-.068a3.275 3.275 0 0 1 1.068-.405c1.846-.364 3.655.745 4.097 2.515Zm-3.396-6.938c1.093 0 1.98.857 1.98 1.913 0 1.054-.888 1.912-1.98 1.912-1.101 0-1.988-.856-1.987-1.92.001-1.052.892-1.906 1.987-1.905ZM4.835 0c1.496-.007 2.69 1.133 2.695 2.575.006 1.413-1.184 2.567-2.651 2.572-1.466.005-2.664-1.136-2.68-2.551C2.183 1.19 3.385.006 4.835 0Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupShare);
export default ForwardRef;